export const openInNewTab = (url: string) => {
    if (!url) {
        console.error("URL not provided");
        return;
    }
    window.open(url, "_blank") || window.location.replace(url);
};
